import { render } from "./ImgBorder.vue?vue&type=template&id=a5332720&scoped=true"
import script from "./ImgBorder.vue?vue&type=script&lang=ts"
export * from "./ImgBorder.vue?vue&type=script&lang=ts"

import "./ImgBorder.vue?vue&type=style&index=0&id=a5332720&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a5332720"

export default script